<template>
  <v-flex data-qa="current-flex-7xyq8s">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="ml-2 pt-0" data-qa="current-layout-64unjg">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="current-flex-koypr8">
        <v-container data-qa="current-container-rt712a">
          <v-flex xs12 sm12 md12 lg12 xl12 class="px-2" data-qa="current-flex-ry1nl9">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="current-flex-gtl2eb">
              <v-row no-gutters class="pb-2" data-qa="current-row-weztbv">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <font class="display-1 font-weight-thin white--text pt-4 pl-2">
                    {{$t("common.currentLabel")}} <font v-if="showTotalAccountsAvailable">({{ currentAccount.accounts.length }})</font>
                  </font>
              </v-row>
            </v-flex>
            <v-row class="px-2 pl-6" data-qa="current-row-v4262i">
              <v-layout row wrap v-if="showTotalBalance && !isMultiCurrency" data-qa="current-layout-ypvdi">
                <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="current-flex-j7l1oc">
                  <font class="subheading-1 font-weight-medium white--text">{{
                    $t("accountDetails.totalBalance")
                  }}</font>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="current-flex-m2fdzl">
                  <font class="text-h5 font-weight-bold white--text">{{
                    $formatter.currency.format(accDetails.myBalance, accDetails.currency)
                  }}</font>
                </v-flex>
              </v-layout>

              <v-layout v-if="enableOpenNewAccountOption" class="py-2" data-qa="current-layout-m3g9s4">
                <v-flex sm12 xs12 md12 lg12 xl12 class="text-right" data-qa="current-flex-re119g">
                  <v-btn
                    @click="goToOffer('CACC')"
                    color="white"
                    class="text-none py-2 px-4"
                    outlined
                     data-qa="current-btn-8jbvir">{{$t("common.openNewAccountLabel")}}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="current-flex-efpq7u">
      <CardLayout :config="currentAccount" />
    </v-flex>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import preload from '@/util/preload'
import store from '@/core/store'
import event from '@/util/event'
import CardLayout from '@/views/home/HomeCards.vue'
import Loader from '../../components/common/Loader.vue'

export default {
  name: 'Current',
  components: {
    Loader,
    CardLayout
  },
  data () {
    return {
      accountType: 'CACC',
      loaderEnabled: false,
      currentAccount: {
        title: this.$t('common.currentTypeLabel'),
        cardLabels: false,
        openNewACCard: false,
        enableShowMore: false,
        accounts: []
      },
      accDetails: {
        currency: '',
        myBalance: 0,
        series: []
      },
      baseCurrency: this.$appSettings.defaultConfigurations.currencyFormat.currency,
      enableOpenNewAccountOption: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
      showTotalBalance: this.$appSettings.defaultConfigurations.totalBalanceSection.enableCurrentSection,
      showTotalAccountsAvailable: this.$appSettings.defaultConfigurations.showTotalAccountsAvailable.enableCurrentSection,
      isMultiCurrency: false,
      viewClosedAccountsList: this.$appSettings.defaultConfigurations.viewClosedAccountsList,
      excludedAccountStatus: this.$appSettings.uiFieldsDisplayConfigurations.casaAccountListing.exclusionList
    }
  },
  beforeCreate () {
    if (this.$route.params.reload) {
      location.reload()
    }
  },
  created () {
    if (this.$route.params && this.$route.params.from === 'Dashboard') {
      this.currentAccount.enableShowMore = true
    } else this.currentAccount.enableShowMore = false
    // const exclusionList = this.$appSettings.uiFieldsDisplayConfigurations
    //   .tableColumns.accountListTables.exclusionList
    event.$on('set_myAccounts', () => {
      this.getListOfAccounts()
      // this.fetchAccounts()
      this.loaderEnabled = false
    })
    if (this.ifMyAccountsAvailable()) {
      this.getListOfAccounts()
      // this.fetchAccounts()
    } else {
      this.loaderEnabled = true
      preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Current2')
    },
    goToOffer (type) {
      this.$router.push({
        name: 'Current Products',
        params: { accountType: type }
      })
    },
    getListOfAccounts () {
      this.loaderEnabled = true
      const data = store.getters['userStore/userData'].myAccounts
      if (data) {
        this.currentAccount.accounts = data.currentAccounts
          ? data.currentAccounts.accountList
          : []
        if (this.currentAccount.accounts.length) {
          this.currentAccount.accounts = _.filter(
            this.currentAccount.accounts,
            account => {
              if (this.viewClosedAccountsList && this.viewClosedAccountsList.length &&
                this.viewClosedAccountsList.includes(account.accountType) && account.accountStatus === 'CLOSED') {
                return account
              } else return !(this.excludedAccountStatus.includes(account.accountStatus))
            })
        }
        for (const i in data) {
          if (data[i].accountList[0]) {
            this.accDetails.currency = data[i].accountList[0].currency
          }
          switch (data[i].label) {
            case 'currentAccounts':
              this.accDetails.series.push(data[i].totalCurrentBalance)
              this.accDetails.myBalance += data[i].totalCurrentBalance
              break
            default:
              break
          }
        }
      }
      this.loaderEnabled = false
    },
    fetchAccounts () {
      this.loaderEnabled = true
      const accounts = store.getters['userStore/userData'].myAccounts
      const currentAccounts = accounts.currentAccounts.accountList
      if (currentAccounts && currentAccounts.length) {
        this.currentAccountList.list = []
        const excludeAccountStatus = ['INACTIVE', 'BLOCKED', 'STOPPED']
        for (const i in currentAccounts) {
          if (excludeAccountStatus.includes(currentAccounts[i].accountStatus)) {
            currentAccounts[i].balance = this.$t(
              'myAccounts.notAvailableLabel'
            )
          } else {
            if (!isNaN(currentAccounts[i].balance)) {
              currentAccounts[i].balance = this.getBalInfo(
                currentAccounts[i].balance
              )
            } else {
              if (
                !currentAccounts[i].balance &&
                currentAccounts[i].accountStatus === 'ACTIVATED'
              ) {
                currentAccounts[i].balance = this.$t(
                  'myAccounts.balanceInquiryRestricted'
                )
              }
            }
          }
          this.currentAccountList.list.push({
            ...currentAccounts[i],
            status: this.$t(
              `systemEnums.casa.${currentAccounts[i].accountStatus}`
            ),
            accountNumber: currentAccounts[i].accountId
          })
        }
        this.loaderEnabled = false
      } else {
        this.loaderEnabled = false
      }
    },
    ifMyAccountsAvailable () {
      return store.getters['userStore/userData'].myAccounts
    },
    getBalInfo (bal) {
      if (bal !== undefined && bal.toString().trim().length > 0) {
        if (isNaN(bal)) {
          return bal
        } else {
          return this.$formatter.currency.format(bal)
        }
      } else {
        return this.$t('myAccounts.notAvailableLabel')
      }
    }
  }
}
</script>
